export default {
  missingPeriodsLabel: 'Missing periods',
  missingPeriodsDesc: '{count} periods between the first and last date of this series have no data. Check that no rows are missing.',
  shorterThanKpiLabel: 'Shorter than sales',
  shorterThanKpiDesc: 'This series starts later or ends earlier than the sales data. That is fine if it had no activity then.',
  outlierLabel: 'Unusual values',
  outlierDesc: '{count} periods are far above or below the usual level of this series. Check for typos, extra zeros or a different unit.',
  negativeLabel: 'Negative values',
  negativeDesc: '{count} rows have negative values.',
  zerosLabel: 'Zero sales',
  zerosDesc: '{count} periods have sales equal to zero.',
  allZeroLabel: 'Only zeros',
  allZeroDesc: 'Every value of this series is zero.',
  constantLabel: 'Same value',
  constantDesc: 'This series has the same value in every period. Check it is not a placeholder.',
  mixedFrequencyLabel: 'Different frequency',
  mixedFrequencyDesc: 'This series has a different frequency (for example monthly instead of weekly) than the rest of the sheet.',
  weekdayMismatchLabel: 'Shifted dates',
  weekdayMismatchDesc: 'Some weeks of this series start on a different weekday than the rest of the sheet, so part of its data may be shifted.',
  repeatedRowsLabel: 'Repeated rows',
  repeatedRowsDesc: '{count} rows repeat the same series, date and dimensions, so their values are added together.'
}
